import React, { useRef, useState } from 'react'
import Menu from '@mui/material/Menu'
import Api from '../../_helpers/Api'
import { trans } from '../../_providers/Translation'
import { useNotificationsContext } from '../../_providers/Notifications'
import { usePaymentMethodIcon } from '../../_helpers/usePaymentMethodIcon'

// modals
import Question from '../modals/messages/Question'

// icons
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import unpaidIcon from "@/assets/img/icons/unpaid.svg"

const todayDate = () => {
    const now = new Date()
    const pad = n => String(n).padStart(2, '0')
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
}

function InvoicePaymentMethodMenu(props) {

    const notifications = useNotificationsContext()
    const questionModalRef = useRef(null)
    const getMethodIcon = usePaymentMethodIcon()

    const [anchor, setAnchor] = useState(null)
    const [loading, setLoading] = useState(false)

    const handleOpen = e => {
        e.stopPropagation()
        setAnchor(e.currentTarget)
    }

    const handleClose = () => setAnchor(null)

    const handleSelect = method => {
        handleClose()

        const modal = questionModalRef.current

        modal.open()
        modal.onSuccess(() => save(method))
    }

    const save = method => {
        setLoading(true)

        const data = new FormData()
        data.append('id', props.invoice.id)
        data.append('method_id', method.id)
        data.append('date', todayDate())

        Api.post('invoices/mark-as-paid', data)
            .then(res => {
                if (res.data.success) {
                    notifications.add(trans('messages.paymentStatsChanged'))

                    if (typeof props.refreshData === 'function') {
                        props.refreshData()
                    }
                }
            })
            .finally(() => setLoading(false))
    }

    return (
        <div className="payment-method-menu" onClick={e => e.stopPropagation()}>
            <Question
                ref={questionModalRef}
                mainMessage={trans('headings.question15')}
            />

            <button
                type="button"
                className="payment-method-trigger"
                onClick={handleOpen}
                disabled={loading}
                style={{
                    marginLeft: "-5px"
                }}
            >
                <span style={{
                    display: 'flex', alignItems: 'center', gap: '5px'
                }}>
                    <img src={unpaidIcon} alt="unpaid" style={{
                        width: "17px",
                        height: "17px",
                        flexShrink: 0,
                        objectFit: "contain",
                        padding: "2.5px"
                    }} />
                    {trans('tables.unpaid')}
                </span>
                <KeyboardArrowDownIcon style={{ width: 18, height: 18 }} />
            </button>

            <Menu
                anchorEl={anchor}
                keepMounted
                open={Boolean(anchor)}
                onClose={handleClose}
            >
                {props.methods.map(method =>
                    <div
                        key={method.id}
                        className="menu-option"
                        onClick={() => handleSelect(method)}
                    >
                        {getMethodIcon(method)}
                        {method.translation ? method.translation.name : method.name}
                    </div>
                )}
            </Menu>
        </div >
    )
}

export default InvoicePaymentMethodMenu
